import GGTxnReferralBanner from '@atoms/GGTxnReferralBanner';
import AdMobBanner from '@root/components/ads/AdMobBanner';
import TextCurrency from '@atoms/TextCurrency';
import { Button, Text, View } from '@components/primitives';
import useFeatureFlag from '@customHooks/useFeatureFlag';
import { Feather } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import appStyles from '@root/appStyles';
import { AD_MOB_FEATURE_FLAG } from '@root/config/admobConfig';
import { getStore } from '@store/storeUtils';
import colors from '@theme/colors';
import { AMPLITUDE_CONSTANTS, AMPLITUDE_EVENT_SOURCES } from '@utils/analytics/constants';
import { scale } from '@utils/normalize';
import { SVG_ICONS } from '@utils/SvgIcons';
import { goBackToHome } from '@utils/utils';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ScrollView } from 'react-native';
import styles from './styles';

type GGBPSuccessProps = {
  route: {
    params: {
      productConfig: {
        transaction_category_id: string;
        reason: string;
        reasonId: string;
      };
      selectedBPAccountForConfirm: {
        amplitudeAccountName: string;
      };
      source: string;
      bpReqData: {
        subtotal: number;
        productName: string;
        productCode: string;
        fee: number;
      };
      productApiData: {
        screenName: string;
      };
    };
  };
};

function GGBPSuccess(props: GGBPSuccessProps) {
  const navigation = useNavigation();
  const { setValidatedReferralCode, setReferralValidated, headerText } = getStore();
  const { t } = useTranslation('common');
  const [isFeatureAvailale] = useFeatureFlag({
    featureName: [AD_MOB_FEATURE_FLAG],
  });

  const { route } = props;
  const { params } = route;
  const { productApiData, bpReqData } = params;
  const { screenName } = productApiData;
  const { subtotal, productName } = bpReqData;
  const adMobFeature = isFeatureAvailale[AD_MOB_FEATURE_FLAG];

  useEffect(() => {
    navigation.setOptions({ title: headerText, headerBackVisible: false });
  }, []);

  const e = AMPLITUDE_CONSTANTS.interactionBanner.banner_clicked;

  return (
    <View style={appStyles.safeAreaView}>
      <View style={styles.container}>
        <ScrollView
          style={styles.scrollView}
          contentContainerStyle={styles.scrollContentContainer}
          showsVerticalScrollIndicator={false}>
          <View style={styles.scrollBody}>
            <View style={styles.successParent}>
              {SVG_ICONS.Clock}
              <Text
                testID="txnInProcess"
                variant="xl-bold"
                color={colors.warning.sunflower}
                style={appStyles.marginTop(16)}>
                {t('successPage.txInProcess')}
              </Text>
              <Text testID="txtPurchased" variant="lg-normal" style={appStyles.marginTop(12)}>
                {t('successPage.purchased')} {screenName}
              </Text>
              <TextCurrency
                style={appStyles.marginTop(12)}
                amountCurrency={subtotal}
                showCurrencySymbol
                color={colors.secondary.orchid}
                variant="xxl-bold"
                testID="txtCurrencyFormat"
              />
              <Text
                testID="txtProductName"
                variant="md-bold"
                color={colors.neutral.darkMist}
                style={appStyles.marginTop(12)}>
                {productName}
              </Text>
              <View testID="txtSuccess" style={styles.successInfo}>
                <Feather testID="txtInfoIcon" name="info" size={scale(24)} color={colors.secondary.orchid} />
                <Text
                  testID="txTimeTaken"
                  variant="xsm-bold"
                  color={colors.neutral.charcoal}
                  style={{ marginLeft: scale(8) }}>
                  {t('successPage.txTimeTaken')}
                </Text>
              </View>
            </View>

            <View style={styles.promoSection}>
              <AdMobBanner
                adMobFeatureFlag={adMobFeature}
                adAuditContext={{
                  screen: 'GGBPSuccess',
                  placement: 'success_promo_banner',
                  flow: 'bill_payment',
                }}
              />

              <GGTxnReferralBanner
                customStyles={styles.txnBannerStyle}
                logParams={{
                  [e.attributes.transaction_category_id]: route?.params?.productConfig?.transaction_category_id,
                  [e.attributes.reason]: route?.params?.productConfig?.reason,
                  [e.attributes.reason_id]: route?.params?.productConfig?.reasonId,
                  [e.attributes.source]: AMPLITUDE_EVENT_SOURCES.success_page,
                  [e.attributes.dynamic_account_name]: route?.params?.selectedBPAccountForConfirm?.amplitudeAccountName,
                }}
              />
            </View>
          </View>
        </ScrollView>

        <View style={[appStyles.borderWithShadow, styles.bottomView]}>
          <Button
            size="lg"
            testID="btnHome"
            style={styles.okButton}
            onPress={() => {
              setValidatedReferralCode(null);
              setReferralValidated(false);
              goBackToHome(navigation);
            }}>
            {t('common.ok')}
          </Button>
        </View>
      </View>
    </View>
  );
}

export default GGBPSuccess;
